module.exports = __webpack_public_path__ + "static/media/mail.7cfd00c0.svg";